import axios from 'axios';
import log from '../../logger';

/**
 * The report list the React reporting page renders, and the exports behind it.
 *
 * Replaces Angular's `reportingService`, which reached React through `addReport`/`getReports`
 * on the CMS context. The shape is unchanged so the reporting page did not have to move: a
 * mutable array that plugins can push onto, and a getter.
 *
 * `$sce.trustAsResourceUrl` is gone from `getReportingIframeUrl`. It existed because Angular
 * refuses to put an untrusted URL in an `iframe src`; React has no such notion, and the URL
 * comes from our own server.
 *
 * Every generator below is a `function` declaration, not an arrow const. The list literal
 * references them, and it is evaluated when this module is imported, so a `const` arrow would
 * be in its temporal dead zone and throw before the CMS rendered anything.
 */
async function get(url, params) {
  try {
    const { data } = await axios.get(url, params ? { params } : undefined);
    return data;
  } catch (error) {
    log.error(`Failed to load ${url}`, error);
    throw error;
  }
}

async function getReportingIframeUrl() {
  const data = await get('/plugins/reporting/api/getQuicksightUrl');
  return data.url;
}

function getAllUserActivity({ startDate, endDate } = {}) {
  return get('/plugins/reporting/api/getAllUserActivity', { startDate, endDate });
}

function getUniqueUserActivity({ startDate, endDate } = {}) {
  return get('/plugins/reporting/api/getUniqueUsersWithActivity', { startDate, endDate });
}

function getAllUsersExport() {
  return get('/plugins/reporting/api/getAllUsersExport');
}

const reports = [
  {
    reportId: 'all_users',
    reportName: 'Users / Groups',
    isExport: true,
    reportGenerator: getAllUsersExport,
    reportButtonLabel: 'Generate Report',
  },
  {
    reportId: 'advanced_reporting',
    reportName: 'Advanced Reporting',
    isIframe: true,
    reportGenerator: getReportingIframeUrl,
    reportButtonLabel: 'Open',
    enabledCheck: (pluginConfig) => !!pluginConfig.quicksightConfig,
  },
  {
    reportId: 'activity_all',
    reportName: 'Active Users',
    reportGenerator: getAllUserActivity,
    isExport: true,
    dateRange: true,
  },
  {
    reportId: 'activity_unique_user',
    reportName: 'Active Unique Users',
    reportGenerator: getUniqueUserActivity,
    isExport: true,
    dateRange: true,
  },
];

export const addReport = (reportInfo) => reports.push(reportInfo);
export const getReports = () => reports;
